import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import { SupabaseSubmitFeedbackRepository } from '@/modules/feedback/infra'
import type { SubmitFeedback } from '@/modules/feedback/use-cases'

export function makeSubmitFeedback(): SubmitFeedback {
  return new SupabaseSubmitFeedbackRepository(makeSupabaseEdgeHttpClient()).execute
}
